import { LayoutDashboardIcon, UsersIcon } from "lucide-react";
import { Link } from "react-router-dom";
import {
    SidebarGroup,
    SidebarGroupContent,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from "@/components/ui/sidebar";
import { AppRoutes } from "@/types/routes";

const adminNavItems = [
    {
        title: "Dashboard",
        url: AppRoutes.PortalDashboard,
        icon: LayoutDashboardIcon,
    },
    {
        title: "Users",
        url: AppRoutes.PortalUsers,
        icon: UsersIcon,
    },
];

export const NavMain = () => (
    <SidebarGroup>
        <SidebarGroupContent className="flex flex-col gap-2">
            <SidebarMenu>
                {adminNavItems.map(item => (
                    <SidebarMenuItem key={item.title}>
                        <SidebarMenuButton
                            tooltip={item.title}
                            asChild
                        >
                            <Link
                                to={item.url}
                                className="flex items-center gap-2"
                            >
                                {item.icon && <item.icon />}
                                <span>{item.title}</span>
                            </Link>
                        </SidebarMenuButton>
                    </SidebarMenuItem>
                ))}
            </SidebarMenu>
        </SidebarGroupContent>
    </SidebarGroup>
);
